import { BrandfolderHexColors, FontWeights, StandardText } from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';

interface PagesNameProps extends HTMLAttributes<HTMLDivElement> {
  name: string;
  current?: boolean;
  page?: boolean;
}

const UnstyledPagesName: FunctionComponent<PagesNameProps> = (props) => {
  const { current, name, page, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      className={classNames({
        'pages-name': true,
        'pages-name--current': current,
        'pages-name--page': page,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
    >
      <StandardText
        className={classNames({
          'pages-name__name': true
        })}
        weight={page ? FontWeights.Medium : undefined}
      >
        {name}
      </StandardText>
      {current && page && <StandardText className="pages-name__current">Current Page</StandardText>}
    </div>
  );
};

const StyledPagesName = styled(UnstyledPagesName)`
  flex: 1;
  margin-left: 4px;
  margin-right: 4px;

  &.pages-name--page {
    .pages-name__name {
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }

  .pages-name__current {
    color: ${BrandfolderHexColors.GrayDark};
    font-size: 11px;
    line-height: 14px;
  }
`;

export const PagesName: FunctionComponent<PagesNameProps> = (props) => {
  return <StyledPagesName {...props} />;
};
